// Carer-parity S3a / Sub-6 6a — minimal top-bar chrome for carer pages.
// Sticky navy-800 header with optional back affordance + title/subtitle +
// optional right-side slot. Mirrors the header shape carer pages have been
// open-coding (CarerHomePage, CarerVisitDetailPage), but we don't refactor
// those at S3a — only new pages opt in (CarerVisitReportPage). A later
// pass can fold the existing pages into this component.

import type { JSX, ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  rightSlot?: ReactNode;
}

export function CarerTopBar({ title, subtitle, onBack, rightSlot }: Props): JSX.Element {
  return (
    <header
      className="bg-navy-800 text-white sticky top-0 z-10 shadow-md"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
      data-testid="carer-top-bar"
    >
      <div className="max-w-lg mx-auto px-4 py-4 flex items-center gap-3">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="Back"
            className="text-navy-200 hover:text-white text-2xl leading-none"
          >
            ←
          </button>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="font-bold text-lg truncate">{title}</h1>
          {subtitle && <p className="text-navy-200 text-xs truncate">{subtitle}</p>}
        </div>
        {rightSlot}
      </div>
    </header>
  );
}
